import React from "react";
import classes from "./style.module.css";
import GamePadIcon from "../../../../assets/images/icons/gamePadIcon.svg";
import {
  convertToShamsi,
  convertToShamsiTime,
} from "../../../../assets/utils/ConvertToShamsi";
// import { useDispatch } from "react-redux";
// import QuizRequests from "../../../../assets/services/quiz";
// import {
//   setfinalizeQuiz,
//   setfinalizeReport,
//   setAnsweredQuestoinsCount,
//   setQuestionAnswer,
//   setLastQuestionId,
//   setMaxAnswer,
//   setShowFinalizeModal,
// } from "../../../../assets/redux/actions/Quiz";
import { useNavigate } from "react-router-dom";
// import StartMatchAlert from "../../alertContents/StartMatchAlert";

export default function KhazaneListElement({ quiz }) {
  // const [showDialog, setShowDialog] = useState(false);
  // const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleStartMatch = () => {
    navigate(`/preMatch/${quiz._id}`);
    // dispatch(setfinalizeQuiz(false));
    // dispatch(setfinalizeReport(null));
    // dispatch(setAnsweredQuestoinsCount(null));
    // dispatch(setQuestionAnswer(null));
    // dispatch(setLastQuestionId(""));
    // dispatch(setMaxAnswer(0));
    // dispatch(setShowFinalizeModal(false));
    // try {
    //   const ticket = await dispatch(QuizRequests.startQuiz(quiz._id));
    //   localStorage.removeItem("Ticket");
    //   localStorage.setItem("Ticket", ticket._id);
    //   if (ticket.lastQuestionId !== null) {
    //     dispatch(setLastQuestionId(ticket.lastQuestionId));
    //     navigate(`/questions/${quiz._id}`);
    //   } else {
    //     dispatch(setLastQuestionId(""));
    //     navigate(`/questions/${quiz._id}`);
    //   }
    // } catch (error) {
    //   console.log(error);
    // }
  };

  return (
    <>
      <div className={classes.listElContainer} onClick={handleStartMatch}>
        <div className={classes.timeContainer}>
          <p>{convertToShamsiTime(quiz.createdAt)}</p>
          <p>{convertToShamsi(quiz.createdAt)}</p>
        </div>
        <div className={classes.titleContainer}>
          <img src={GamePadIcon} alt="gameBoyIcon" />
          <p>{quiz.title}</p>
        </div>
        <div className={classes.descContainer}>
          <p dangerouslySetInnerHTML={{ __html: quiz.description }}></p>
        </div>
      </div>
      {/* <StartMatchAlert
        show={showDialog}
        startMatch={handleStartMatch}
        handleClose={() => setShowDialog(false)}
      /> */}
    </>
  );
}
